var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"stepper",style:({
      backgroundColor: _vm.currentStep === _vm.steps.length - 1 ? 'var(--primary-color)' : 'grey'
    })},_vm._l((_vm.steps),function(step,index){return _c('div',{key:step,staticClass:"step",class:{active: _vm.currentStep >= index},style:({
        borderColor: index <= _vm.currentStep ? _vm.color : 'white',
      }),on:{"click":function($event){return _vm.$emit('stepTo', index)}}},[_c('span',{staticClass:"step-name is-size-5",style:({
          position: 'relative',
          left: '12px'
        })},[_vm._v(_vm._s(step))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }